// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__5xyYV","logo__img":"Logo_logo__img__o5O1L"};